// =============================================================================
// PAYMENT PAGE
// =============================================================================

import React from 'react';
import { PaymentScreen } from '@/components/Payment/PaymentScreen';
import { SEOHead } from '@/components/SEO';
import { seoData } from '@/data/seoData';
import { useAnalytics } from '@/hooks/useAnalytics';

export const PaymentPage: React.FC = () => {
  useAnalytics('Payment - Awani');
  return (
    <>
      <SEOHead
        title={seoData.payment.title}
        description={seoData.payment.description}
        keywords={seoData.payment.keywords}
        canonicalUrl={seoData.payment.canonicalUrl}
        noIndex={seoData.payment.noIndex}
      />
      <PaymentScreen />
    </>
  );
};

export default PaymentPage;
